import React, { useContext, useEffect, useState } from "react";
import { Modal, ModalBody } from "@windmill/react-ui";
import { SidebarContext } from "context/SidebarContext";
import SeoVirtualServices from "services/SeoVirtualServices";
import useAsync from "hooks/useAsync";
import CommonCloseBtn from "components/CloseButton/CommonCloseButton";
const ViewContactModal = ({ id, title }) => {
 const { isViewModalOpen, closeModal, setIsUpdate } =
  useContext(SidebarContext);

  // var result = data.find((item) => item.id === id);

  const [result, setResult] = useState(null);
  const { data, loading, error } = useAsync(
    async () => {
      if (!id) return null;
      return SeoVirtualServices.getcontactById(id);
    },
    [id]
  );

  useEffect(() => {
    if (!loading && data) {
      const contact =
        data?.data?.data ??
        data?.data ??
        data;

      setResult(contact);
    }
  }, [data, loading]);

  useEffect(() => {
    if (error) console.error(error);
  }, [error]);

  const style = `{                                      
      .custom-modal button {
        position: absolute;
        top: 10px;
        right: 10px;
        background-color: transparent;
        border: none;
        cursor: pointer;
        font-size: 16px;
        color: #333;
        outline:none !important;
      }
      .custom-modal button:hover {
        color: #FF0000 !important; 
        outline:none;
        
      } .custom-modal button:focus {
        color: #FF0000 !important; 
        outline:none; 
      }
    .custom-modal {
  
    overflow-y-auto; /* Enable scrolling if the content overflows */
  }
      
      `;

  return (
    <>
      <style>{style}</style>

      <Modal
        className="relative bg-white dark:bg-gray-700 dark:text-white w-1/2 rounded-lg"
        isOpen={isViewModalOpen}
        onClose={() => {
          closeModal();
           setIsUpdate(true);
        }}
      >
        <ModalBody className="custom-modal" style={{ margin: "0" }}>
          <CommonCloseBtn onClose={closeModal}/>
          <h2 className="text-center font-bold text-lg">{title}</h2>

          <div
            className="max-h-96 overflow-y-auto p-5"
            style={{ maxHeight: "60vh", scrollbarWidth: "thin" }}
          >
            {loading && (
              <p className="text-center py-6 text-gray-500">
                Loading contact details...
              </p>
            )}
            {!loading && result && (
              <dl className="border rounded-lg border-gray-300 dark:border-gray-500 text-sm dark:text-white">
                <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                  <dt className="font-medium text-gray-900 dark:text-gray-200">
                    Name
                  </dt>
                  <dd
                    className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20 "
                    style={{
                      overflowWrap: "break-word",
                      whiteSpace: "normal",
                    }}
                  >
                    {result?.name ||
                      `${result?.firstname || ""} ${result?.lastname || ""
                        }`.trim() ||
                      "-"}
                  </dd>
                </div>

                <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                  <dt className="font-medium text-gray-900 dark:text-gray-200">
                    Email
                  </dt>
                  <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                    {result?.email}
                  </dd>
                </div>

                <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                  <dt className="font-medium text-gray-900 dark:text-gray-200">
                    Phone
                  </dt>

                  <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                    {result?.phone}
                  </dd>
                </div>

                <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                  <dt className="font-medium text-gray-900 dark:text-gray-200">
                    Company Name
                  </dt>

                  <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                    {result?.company_name || "-"}
                  </dd>
                </div>

                <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                  <dt className="font-medium text-gray-900 dark:text-gray-200">
                    Company Website Url
                  </dt>

                  <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                    {result?.company_website_url || "-"}
                  </dd>
                </div>

                <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                  <dt className="font-medium text-gray-900 dark:text-gray-200">
                    Message
                  </dt>

                  <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                    {result?.message || "Null"}
                  </dd>
                </div>

                <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                  <dt className="font-medium text-gray-900 dark:text-gray-200">
                    Subject
                  </dt>

                  <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                    {result?.subject || "-"}
                  </dd>
                </div>
              </dl>
            )}
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default React.memo(ViewContactModal);
